import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { LogoAr } from '../../ui/AllImages'

const Privacy = () => {
    useEffect(() => { document.title = 'سياسة الخصوصية — صولا للديكور' }, [])
    return (
        <Wrap dir="rtl" lang="ar">
            <header><Link to="/" aria-label="صولا"><LogoAr /></Link></header>
            <main>
                <h1>سياسة الخصوصية</h1>
                <p>توضح هذه الصفحة كيف تتعامل <b>مؤسسة صولا للديكور</b> مع بياناتك عند زيارة موقعنا أو التواصل معنا.</p>

                <h2>البيانات التي نجمعها</h2>
                <ul>
                    <li>بيانات التواصل التي ترسلها لنا بنفسك عبر واتساب أو الاتصال أو نموذج التواصل، مثل الاسم ورقم الجوال والبريد الإلكتروني وتفاصيل طلبك.</li>
                    <li>بيانات استخدام عامة للموقع، مثل الصفحات التي تزورها والضغط على أزرار التواصل.</li>
                </ul>

                <h2>كيف نستخدمها</h2>
                <ul>
                    <li>للرد على استفساراتك وتقديم عروض الأسعار وتنفيذ طلبك.</li>
                    <li>لقياس أداء إعلاناتنا وتحسينها. نستخدم لهذا الغرض أداة قياس من سناب شات (Snap Pixel) تسجّل زيارة الصفحات والضغط على أزرار التواصل.</li>
                </ul>

                <h2>مشاركة البيانات</h2>
                <p>لا نبيع بياناتك ولا نؤجرها لأي جهة. لا نشاركها إلا مع مزودي الخدمات اللازمين لتشغيل الموقع والإعلانات، أو عندما يطلبها نظام نافذ في المملكة العربية السعودية.</p>

                <h2>حقوقك</h2>
                <p>يحق لك طلب الاطلاع على بياناتك أو تصحيحها أو حذفها في أي وقت عبر التواصل معنا على الرقم <a href="tel:+966560532519">0560532519</a>.</p>

                <h2>التواصل</h2>
                <p>مؤسسة صولا للديكور — حي المونسية - شارع الصحابة - مبنى رقم 6654 - الرياض.</p>
                <p className="back"><Link to="/">العودة للموقع الرئيسي</Link></p>
            </main>
        </Wrap>
    )
}

const Wrap = styled.div`
    font-family: var(--arRegular), Tahoma, sans-serif;
    background: var(--bg, #F8F2E6); min-height: 100vh; color: #2b1a10; text-align: right;
    header { background: #fff; padding: 12px 16px; border-bottom: 1px solid var(--stroke, #D6C3AB); svg { height: 40px; width: auto; } }
    main { max-width: 760px; margin: 0 auto; padding: 24px 16px 48px; font-size: 17px; line-height: 1.9; }
    h1, h2 { font-family: var(--arBold), Tahoma, sans-serif; color: var(--secondaryColor, #521501); }
    h1 { font-size: 30px; } h2 { font-size: 21px; margin-top: 24px; }
    a { color: var(--secondaryColor, #521501); }
    .back { margin-top: 28px; }
`

export default Privacy
